import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const CustomPagination = ({current = 1, total, pageSize = 10, onChange, onShowSizeChange}) => {
	const totalPages = Math.max(1, Math.ceil(total / pageSize));

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				padding: 2,
			}}>
			<Box sx={{display: "flex", alignItems: "center", gap: 2}}>
				<Typography variant="body2" color="text.secondary">
					Showing {total > 0 ? (current - 1) * pageSize + 1 : 0} to {Math.min(current * pageSize, total)} of {total} entries
				</Typography>
			</Box>

			<Box sx={{display: "flex", alignItems: "center", gap: 2}}>
				<Typography variant="body2" color="text.secondary">
					Page {current} of {totalPages}
				</Typography>

				<Box sx={{display: "flex", alignItems: "center", gap: 1}}>
					<Button variant="outlined" size="small" disabled={current === 1} onClick={() => onChange?.(current - 1, pageSize)} sx={{minWidth: "32px", height: "32px", p: 0}}>
						&lt;
					</Button>

					<Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
						<input
							type="number"
							value={current}
							onChange={(e) => {
								const newPage = parseInt(e.target.value, 10);
								if (newPage >= 1 && newPage <= totalPages) {
									onChange?.(newPage, pageSize);
								}
							}}
							style={{
								width: "50px",
								height: "32px",
								border: "1px solid #d9d9d9",
								borderRadius: "6px",
								textAlign: "center",
								fontSize: "14px",
								outline: "none",
							}}
						/>
						<Typography variant="body2" color="text.secondary">
							/ {totalPages}
						</Typography>
					</Box>

					<Button variant="outlined" size="small" disabled={current >= totalPages} onClick={() => onChange?.(current + 1, pageSize)} sx={{minWidth: "32px", height: "32px", p: 0}}>
						&gt;
					</Button>
				</Box>

				<Box sx={{display: "flex", alignItems: "center"}}>
					<select
						value={pageSize}
						onChange={(e) => {
							const newPageSize = parseInt(e.target.value, 10);
							// onShowSizeChange?.(current, newPageSize);
							onShowSizeChange?.(1, newPageSize);
						}}
						style={{
							height: "32px",
							border: "1px solid #d9d9d9",
							borderRadius: "6px",
							padding: "0 8px",
							fontSize: "14px",
							outline: "none",
							backgroundColor: "white",
						}}>
						<option value={10}>10 / page</option>
						<option value={20}>20 / page</option>
						<option value={50}>50 / page</option>
						<option value={100}>100 / page</option>
					</select>
				</Box>
			</Box>
		</Box>
	);
};

export default CustomPagination;
